import { APP_CONFIGS } from './Configs';

class ConfigLoader {
  constructor() {
    this.config = new Map();
    this._parseContent();  // Sync parse on init
  }

  // Private: Sync parse bundled content
  _parseContent() {
    const lines = APP_CONFIGS.split('\n');
    for (const line of lines) {
      const trimmed = line.trim();
      if (trimmed && !trimmed.startsWith('#')) {
        const [key, value] = trimmed.split('=', 2);
        this.config.set(key.trim(), value?.trim() ?? '');
      }
    }
  }

  // Get config value
  get(key, defaultValue = null) {
    return this.config.get(key) ?? defaultValue;
  }

  // Set for runtime updates
  set(key, value) {
    this.config.set(key, value);
  }

  // To object
  toObject() {
    return Object.fromEntries(this.config);
  }
}

// Singleton
const configLoader = new ConfigLoader();
export default configLoader;
